import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

function Parametres() {
  const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
  const [iaProvider, setIaProvider] = useState('mistral');
  const [chargement, setChargement] = useState(true);
  const [enregistrement, setEnregistrement] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!storedUser.id) {
      setChargement(false);
      return;
    }
    fetch(`${API_URL}/ia-provider?user_id=${storedUser.id}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.ia_provider) setIaProvider(data.ia_provider);
      })
      .catch((err) => console.error('Erreur chargement préférence IA:', err))
      .finally(() => setChargement(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = async (nouveauFournisseur) => {
    if (nouveauFournisseur === iaProvider || enregistrement) return;
    setEnregistrement(true);
    setMessage('');
    try {
      const response = await fetch(`${API_URL}/ia-provider`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: storedUser.id, ia_provider: nouveauFournisseur })
      });
      const data = await response.json();
      if (response.ok) {
        setIaProvider(nouveauFournisseur);
        setMessage('Préférence enregistrée.');
      } else {
        setMessage(data.error || "Erreur lors de l'enregistrement.");
      }
    } catch (err) {
      console.error('Erreur enregistrement préférence IA:', err);
      setMessage('Erreur de connexion au serveur.');
    } finally {
      setEnregistrement(false);
    }
  };

  if (!storedUser.id) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#ecf0f1', fontFamily: 'Arial, sans-serif' }}>
        <p style={{ color: '#7f8c8d' }}>Vous devez être connecté pour accéder à cette page.</p>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#ecf0f1', fontFamily: 'Arial, sans-serif', padding: '40px 20px' }}>
      <div style={{ background: 'white', padding: '40px', borderRadius: '10px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', width: '100%', maxWidth: '500px', margin: '0 auto' }}>
        <h2 style={{ color: '#2c3e50', margin: '0 0 10px 0' }}>Paramètres</h2>
        <p style={{ color: '#7f8c8d', marginBottom: '30px' }}>Assistant IA</p>

        {chargement ? (
          <p style={{ color: '#7f8c8d' }}>Chargement...</p>
        ) : (
          <>
            <p style={{ color: '#34495e', marginBottom: '15px', fontSize: '14px' }}>
              Fournisseur d'intelligence artificielle utilisé pour les analyses d'audit, l'assistant conversationnel et la génération de documents :
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '12px', border: `2px solid ${iaProvider === 'mistral' ? '#2c3e50' : '#ccc'}`, borderRadius: '8px', cursor: enregistrement ? 'not-allowed' : 'pointer' }}>
                <input
                  type="radio"
                  name="ia_provider"
                  checked={iaProvider === 'mistral'}
                  onChange={() => handleChange('mistral')}
                  disabled={enregistrement}
                />
                <div>
                  <strong>Mistral AI</strong> (par défaut)
                  <div style={{ fontSize: '13px', color: '#7f8c8d' }}>Hébergé en France / Union Européenne</div>
                </div>
              </label>

              <label style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '12px', border: `2px solid ${iaProvider === 'openai' ? '#2c3e50' : '#ccc'}`, borderRadius: '8px', cursor: enregistrement ? 'not-allowed' : 'pointer' }}>
                <input
                  type="radio"
                  name="ia_provider"
                  checked={iaProvider === 'openai'}
                  onChange={() => handleChange('openai')}
                  disabled={enregistrement}
                />
                <div>
                  <strong>OpenAI</strong>
                  <div style={{ fontSize: '13px', color: '#7f8c8d' }}>Hébergé aux États-Unis</div>
                </div>
              </label>
            </div>

            {message && (
              <div style={{ background: message.includes('Erreur') || message.includes('erreur') ? '#e74c3c' : '#2ecc71', color: 'white', padding: '10px', borderRadius: '5px', fontSize: '14px', textAlign: 'center' }}>
                {message}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Parametres;